import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider, Routes, } from 'react-router-dom';
// import { Router } from 'react-router-dom';
// import { createBrowserHistory } from 'history';
import App from './screens/App';
import HomePage from './screens/containers/home/HomePage';
import config from 'config/env';

import { privateComponents } from './privateRouteList';  // Import PRIVATE Routes
import PrivateRoute from './privateRoute';

// // Import NON-PRIVATE Routes
import ReceivePurchaseOrder from './screens/containers/inventory/purchaseOrder/ReceivePurchaseOrder';
import LoginPage from './screens/containers/account/LoginPage';
import ClockInOutPage from './screens/containers/account/ClockInOutPage';
import MySchedulePage from './screens/containers/account/MySchedulePage';
import AccountPage from './screens/containers/account/AccountPage';

import InventoryAudit from './screens/containers/inventory/audit/InventoryAudit';
import PatientSavePage from "./screens/containers/user/patient/PatientSave";
import PatientViewPage from "./screens/containers/user/patient/PatientView";
import ProductSavePage from "./screens/containers/inventory/product/ProductSave";
import ProductViewPage from "./screens/containers/inventory/product/ProductView";

import EmployeeSave from "./screens/containers/user/employee/EmployeeSave";
import EmployeeView from "./screens/containers/user/employee/EmployeeView";
import UserRoleSave from "./screens/containers/user/role/UserRoleSave";
import ReportExamplePage from './screens/containers/report/ReportExamplePage';

import ReportDetailpage from './screens/containers/report/ReportDetailPage';
import OpenOrderList from './screens/containers/admin/order/OpenOrderList';
import OrderDetailPage from './screens/containers/admin/order/OrderDetailPage';
import WebAddMenuPage from './screens/containers/admin/product/WebAddMenuPage';
import CouponPage from './screens/containers/admin/coupon/CouponList';
import EditCouponPage from './screens/containers/admin/coupon/CouponSave';

import ShiftEditPage from './screens/containers/admin/shifts/ShiftEdit';
import ShiftAddPage from './screens/containers/admin/shifts/ShiftAdd';
import GeneralInfoPage from './screens/containers/admin/generalInfo/GeneralInfoPage';
import FaqContentPage from './screens/containers/admin/writing/FaqContent';
import AboutContentPage from './screens/containers/admin/writing/AboutContent';
import HowtoContentPage from './screens/containers/admin/writing/HowtoContent';
import HowtoSave from './screens/containers/admin/writing/HowtoSave';
import LegalContentPage from './screens/containers/admin/writing/LegalContent';

import GiftCardPage from './screens/containers/admin/giftcard/GiftCardPage';
import AnnualSales from './screens/containers/report/annualSales/AnnualSales';
import MonthlyProductSales from './screens/containers/report/monthlyProductSales/monthlyProduct'
import DailyCashSummaryPage from './screens/containers/report/dailyCashSummary/DailyCashSummary';
import ProductSales from './screens/containers/report/productSales/ProductSales';
import SalesSummary from './screens/containers/report/salesSummary/SalesSummary';
import TaxSummary from './screens/containers/report/taxSummary/TaxSummary';
import TransactionDetails from './screens/containers/report/transactionDetails/TransactionDetails';
import BudtenderAvgSales from './screens/containers/report/budtenderAvgSales/BudtenderAvgSales';
import InventoryLevel from './screens/containers/report/inventoryLevel/InventoryLevel';
import EmployeeTotalHours from './screens/containers/report/employee/employeeTotalHours';
import EmployeeTimesheet from './screens/containers/report/timesheet/employeeTimesheet';
import InventorySnapShot from './screens/containers/report/inventorySnapShot/inventorySnapShot';
import MonthlyInventory from './screens/containers/report/MonthlyInventoryReport/MonthlyInventory';
import TransactionSummary from './screens/containers/report/TransactionsSummary/TransactionSummary';
import ProfitReport from './screens/containers/report/ProfitReport/ProfitReport';
import SalesByType from './screens/containers/report/SalesByType/SalesByType';
import RevenueReport from './screens/containers/report/RevenueReport/RevenueReport';
import CustomerSales from './screens/containers/report/customerSales/CustomerSales';
import DestroyedProduct from './screens/containers/report/destroyedProduct/DestroyedProduct';
import ManualInventoryChange from './screens/containers/report/ManualInventoryChange/ManualInventoryChange';
import DiscrepancyReport from './screens/containers/report/discrepancyReport/DiscrepancyReport';
import EndOfDayReport from './screens/containers/report/endOfDayReport/EndOfDayReport';
import ReOrderReport from './screens/containers/report/reorderReport/ReOrderReport';
import MembersDemographics from './screens/containers/report/MemberDemographic/MemberDemographic'
import RestockbyCaps from './screens/containers/report/RestockByCaps/RestockbyCaps'
import CreditPayments from './screens/containers/report/CreditPayments/CreditPayments';
import GiftCardBalance from './screens/containers/report/GiftCardBalance/GiftCardBalance';
import CategorySales from './screens/containers/report/CategorySales/CategorySales';
import PurchaseOrderReceiver from './screens/containers/report/PurchaseOrderReceiver/PurchaseOrderReceiver';
import PurchaseOrderReport from './screens/containers/report/PurchaseOrderReport/PurchaseOrderReport';
import GeneralReport from './screens/containers/report/GeneralReport/GeneralReport';
import HourlySales from './screens/containers/report/HourlySales/HourlySales';
import WarehouseTransfer from './screens/containers/report/WarehouseTransfer/WarehouseTransfer';
import DiscountReport from './screens/containers/report/DiscountReport/DiscountReport';
import DailySalesReport from './screens/containers/report/DailySalesReport/DailySalesReport';
import MonthlySalesReport from './screens/containers/report/MonthlySalesReport/MonthlySalesReport';
import YearlySalesReport from './screens/containers/report/YearlySalesReport/YearlySalesReport';
import SellThroughReport from './screens/containers/report/SellThroughReport/SellThroughReport';
import DailyProfitReport from './screens/containers/report/DailyProfitReport/DailyProfitReport';
import MonthlyProfitReport from './screens/containers/report/MonthlyProfitReport/MonthlyProfitReport';
import YearlyProfitReport from './screens/containers/report/YearlyProfitReport/YearlyProfitReport';
import GMROIReport from './screens/containers/report/GMROIReport/GMROIReport';
import ShoppingTrend from './screens/containers/report/ShoppingTrend/ShoppingTrend';
import AggregateSales from './screens/containers/report/AggregateSales/AggregateSales';
import InventoryBranches from './screens/containers/report/InventoryBranches/InventoryBranches';
import BudgetPlanner from './screens/containers/report/BudgetPlanner/BudgetPlanner';
import AggregateBranches from './screens/containers/report/AggregateBranches/AggregateBranches';
import CombinedSales from './screens/containers/report/CombinedSales/CombinedSales';
import AggregateInventoryLevel from './screens/containers/report/AggregateInventoryLevel/AggregateInventoryLevel';
import BrandReport from './screens/containers/report/BrandSales/BrandReport';
import OrderList from './screens/containers/report/OrderList/OrderList';
import InventoryAge from './screens/containers/report/InventoryAge/InventoryAge';
import CategoryProduct from './screens/containers/report/CategoryProduct/CategoryProduct';
import IRCC from './screens/containers/report/IRCC/IRCC';
import HourlySalesDateRange from './screens/containers/report/HourlySalesDateRange/HourlySalesDateRange';
import HourlySalesSecondary from './screens/containers/report/HourlySalesSecondary/HourlySalesSecondary';
import DeliveryReport from './screens/containers/report/DeliveryReport/DeliveryReport';
import GiftCardReport from './screens/containers/report/GiftCardReport/GiftCardReport';
import InventoryMovement from './screens/containers/report/InventoryMovement/InventoryMovement';
import InventoryLogReport from './screens/containers/report/InventoryLogReport/InventoryLogReport';
import SalesSummaryWithDetails from './screens/containers/report/SalesSummaryWithDetails/SalesSummaryWithDetails';
import AggregateBranchSalesInventory from './screens/containers/report/AggregateBranchSalesInventory/AggregateBranchSalesInventory';
import AuditReport from './screens/containers/report/AuditReport/AuditReport';
import UncountedReport from './screens/containers/report/UncountedReport/UncountedReport';
import StoreList from 'screens/containers/home/StoreList';

import MixAndMatchSavePage from './screens/containers/pricing/mixAndMatch/MixAndMatchSave';
import MixAndMatchListPage from './screens/containers/pricing/mixAndMatch/MixAndMatchList';
import ShiftByDay from './screens/containers/report/shiftByDay/ShiftByDay';
import ShiftByEmployee from './screens/containers/report/shiftByEmployee/ShiftByEmployee';
import SupportDocumentPage from './screens/containers/support/SupportDocument';

// //Online orders
import OnlineOrderDetails from './screens/containers/ecommerce/onlineOrders/onlineOrderDetails';
import OnlineOrderPrepare from './screens/containers/ecommerce/onlineOrders/onlineOrderPrepare';

// // Testing - Lock Screen
import LockScreen from './screens/components/advanced/LockScreen';
import ProductGroupSave from './screens/containers/ecommerce/productGroupSave';
import CarouselSave from './screens/containers/ecommerce/carousel/carouselSave';
import StoreRulesSave from './screens/containers/ecommerce/storerules/storeRulesSave';
import PinPadPassword from './screens/containers/sales/pin/pinpadPassword';

// // Government Compliances
import ComplianceReport from './screens/containers/gov/compliances';
import BulkTransferSave from './screens/containers/inventory/bulkTransfer/bulkTransferSave';
import BulkTransferEdit from './screens/containers/inventory/bulkTransfer/bulkTransferEdit';
import ProductRankingReport from './screens/containers/report/ProductRanking/ProductRankingReport';
import ProductPriceChangeReport from './screens/containers/report/ProductPriceChangeReport/ProductPriceChangeReport';

import HightideReports from './screens/containers/report/HightideReports/HightideReports';
import OnlineInstore from './screens/containers/report/onlineInstore/OnlineInstore';
import PrivateRoutes from 'PrivateRoutes';
import FiskalyCashPointClosingReport from 'screens/containers/report/FiskalyCashPointClosingReport/FiskalyCashPointClosingReport';

import BannerManagement from './screens/containers/ecommerce/bannerList/bannerManagement';

const folderName = config.frontendBaseFolder();

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<App />}>

            <Route index element={<HomePage />} />

            {/* ---------------------  START "MENU" PRIVATE ROUTES --------------------------- */}

            <Route path="/storeList" element={<StoreList />} />
            <Route path="/pos" element={<privateComponents.POSPage />} />

            <Route path="/product/category" element={<privateComponents.ProductCategoryPage />} />
            <Route path="/product" element={<privateComponents.ProductListPage />} />
            <Route path="/purchaseorder" element={<privateComponents.PurchaseOrderPage />} />
            <Route path="/transferproduct" element={<privateComponents.TransferPage />} />
            <Route path="/bulktransferproduct" element={<privateComponents.BulkTransfer />} />
            <Route path="/producthub" element={<privateComponents.InventoryAdjust />} />
            <Route path="/inventoryAudit" element={<privateComponents.InventoryAuditList />} />
            <Route path="/multistoremanagement" element={<privateComponents.MultiStoreManagement />} />
            <Route path="/vendor" element={<privateComponents.VendorPage />} />
            <Route path="/vendorcatalog" element={<privateComponents.VendorCatalog />} />
            <Route path="/member" element={<privateComponents.PatientListPage />} />
            <Route path="/employee" element={<privateComponents.EmployeeList />} />
            <Route path="/doctor" element={<privateComponents.DoctorPage />} />
            <Route path="/userrole" element={<privateComponents.UserRoleList />} />
            <Route path="/admin/bankdeposits" element={<privateComponents.BankDepositPage />} />
            <Route path="/admin/cashregister" element={<privateComponents.CashRegisterPage />} />
            <Route path="/admin/safemanagement" element={<privateComponents.SafeManagementPage />} />
            <Route path="/admin/shift/list" element={<privateComponents.ShiftListPage />} />
            <Route path="/admin/schedule" element={<privateComponents.SchedulePage />} />
            <Route path="/admin/orders" element={<privateComponents.OrderListPage />} />
            <Route path="/admin/marketing" element={<privateComponents.CommunicatingPage />} />
            <Route path="/admin/setting" element={<privateComponents.SettingPage />} />
            <Route path="/report" element={<privateComponents.ReportPage />} />
            <Route path="/manage/measurement" element={<privateComponents.MeasurementPage />} />
            <Route path="/pricematrix" element={<privateComponents.PriceMatrixPage />} />
            <Route path="/manage/taxrate" element={<privateComponents.TaxRatePage />} />
            <Route path="/manage/campaign" element={<privateComponents.CampaignPage />} />
            <Route path="/manage/combo" element={<privateComponents.ComboPage />} />
            <Route path="/manage/discount" element={<privateComponents.DiscountPage />} />
            <Route path="/manage/device" element={<privateComponents.DevicePage />} />
            <Route path="/manage/payment" element={<privateComponents.PaymentPage />} />
            <Route path="/manage/priceupdate" element={<privateComponents.PriceUpdatePage />} />
            <Route path="/ecommerce/online-orders" element={<privateComponents.OnlineOrdersPage />} />
            <Route path="/ecommerce/storerules" element={<privateComponents.StoreRulesPage />} />
            <Route path="/ecommerce/menu" element={<privateComponents.ProductGroupPage />} />
            <Route path="/ecommerce/carousel" element={<privateComponents.CarouselPage />} />
            <Route path="/ecommerce/homesetting" element={<privateComponents.HomeSettingPage />} />
            <Route path="/ecommerce/uisetting" element={<privateComponents.UISettingPage />} />
            <Route path="/ecommerce/seosettings" element={<privateComponents.SEOSettingPage />} />
            <Route path="/ecommerce/bannerList" element={<privateComponents.BannerListPage />} />



            <Route path="/video-support" element={<privateComponents.VideoSupportPage />} />
            <Route path="/newfeatures" element={<privateComponents.NewFeatures />} />
            <Route path="/integration" element={<privateComponents.IntegrationOverview />} />

            {/* ---------------------  END "MENU" PRIVATE ROUTES --------------------------- */}


            {/* ---------------------  START "NON-MENU" PRIVATE ROUTES --------------------------- */}
            <Route path="pos/:id" element={<privateComponents.POSPage />} />

            <Route path="product/category/add" element={<privateComponents.ProductCategoryPage />} />
            <Route path="product/category/edit/:id" element={<privateComponents.ProductCategoryPage />} />

            <Route path="purchaseorder/add" element={<privateComponents.PurchaseOrderPage />} />
            <Route path="purchaseorder/edit/:id" element={<privateComponents.PurchaseOrderPage />} />
            <Route path="purchaseorder/edit/:id/:branchId" element={<privateComponents.PurchaseOrderPage />} />

            <Route path="transferpage" element={<privateComponents.TransferPage />} />

            <Route path="vendor/add" element={<privateComponents.VendorPage />} />
            <Route path="vendor/edit/:id" element={<privateComponents.VendorPage />} />

            <Route path="doctor/add" element={<privateComponents.DoctorPage />} />
            <Route path="doctor/edit/:id" element={<privateComponents.DoctorPage />} />

            <Route path="admin/cashregister/edit/:id" element={<privateComponents.CashRegisterPage />} />

            <Route path="admin/bankdeposits/edit/:id" element={<privateComponents.BankDepositPage />} />
            <Route path="admin/bankdeposits/add" element={<privateComponents.BankDepositPage />} />
            <Route path="admin/safemanagement/add" element={<privateComponents.SafeManagementPage />} />

            <Route path="manage/measurement/add" element={<privateComponents.MeasurementPage />} />
            <Route path="manage/measurement/edit/:id" element={<privateComponents.MeasurementPage />} />

            <Route path="priceMatrix/add" element={<privateComponents.PriceMatrixPage />} />
            <Route path="priceMatrix/edit/:id" element={<privateComponents.PriceMatrixPage />} />

            <Route path="manage/taxrate/add" element={<privateComponents.TaxRatePage />} />
            <Route path="manage/taxrate/edit/:id" element={<privateComponents.TaxRatePage />} />
            <Route path="manage/tax" element={<privateComponents.TaxRatePage />} />
            <Route path="manage/tax/add" element={<privateComponents.TaxRatePage />} />
            <Route path="manage/tax/edit/:id" element={<privateComponents.TaxRatePage />} />

            <Route path="manage/campaign/add" element={<privateComponents.CampaignPage />} />
            <Route path="manage/campaign/edit/:id" element={<privateComponents.CampaignPage />} />

            <Route path="manage/combo/add" element={<privateComponents.ComboPage />} />
            <Route path="manage/combo/edit/:id" element={<privateComponents.ComboPage />} />

            <Route path="manage/discount/add" element={<privateComponents.DiscountPage />} />
            <Route path="manage/discount/edit/:id" element={<privateComponents.DiscountPage />} />

            <Route path="manage/device/add" element={<privateComponents.DevicePage />} />
            <Route path="manage/device/edit/:id" element={<privateComponents.DevicePage />} />

            <Route path="manage/payment/add" element={<privateComponents.PaymentPage />} />
            <Route path="manage/payment/edit/:id" element={<privateComponents.PaymentPage />} />
            {/* ---------------------  END "NON-MENU" PRIVATE ROUTES --------------------------- */}

            {/* ---------------------  USER ROLE EDIT PAGE --------------------------- */}
            {/* <Route path="userrole/add" element={PrivateRoute(UserRoleSave, 15)} />
            <Route path="userrole/edit/:id" element={PrivateRoute(UserRoleSave, 15)} /> */}
            <Route path="/userrole" element={<PrivateRoutes pageIndex={15} />}>
                <Route path="add" element={<UserRoleSave />} />
                <Route path="edit/:id" element={<UserRoleSave />} />
            </Route>


            {/* ---------------------  START NON-PRIVATE ROUTES --------------------------- */}
            {/* PRODUCT */}
            <Route path="product/add" element={<ProductSavePage />} />
            <Route path="product/edit/:id" element={<ProductSavePage />} />
            <Route path="product/:id" element={<ProductViewPage />} />

            {/* ACCOUNT */}
            <Route path="login" element={<LoginPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="clock-in" element={<ClockInOutPage />} />
            <Route path="my-schedule" element={<MySchedulePage />} />

            {/*INVENTORY*/}
            <Route path="purchaseorder/receive/:id" element={<ReceivePurchaseOrder />} />
            <Route path="bulktransferproduct/add" element={<BulkTransferSave />} />
            <Route path="bulktransferproduct/edit/:id" element={<BulkTransferEdit />} />
            <Route path="bulktransferproduct/view/:id" element={<BulkTransferEdit />} />

            {/*MEMBER*/}
            <Route path="member/add" element={<PatientSavePage />} />
            <Route path="member/:id" element={<PatientViewPage />} />
            <Route path="member/edit/:id" element={<PatientSavePage />} />

            {/*CAMPAIGN*/}
            <Route path="ecommerce/menu/add" element={<ProductGroupSave />} />
            <Route path="ecommerce/menu/edit/:id" element={<ProductGroupSave />} />
            <Route path="ecommerce/storerules/add" element={<StoreRulesSave />} />
            <Route path="ecommerce/storerules/edit/:id" element={<StoreRulesSave />} />
            <Route path="ecommerce/carousel/add" element={<CarouselSave />} />
            <Route path="ecommerce/carousel/edit/:id" element={<CarouselSave />} />
            <Route path="ecommerce/online-orders/prepare/:id" element={<OnlineOrderPrepare />} />
            <Route path="ecommerce/online-orders/details/:id" element={<OnlineOrderDetails />} />
            <Route path="employee/add" element={<EmployeeSave />} />
            <Route path="employee/:id" element={<EmployeeView />} />
            <Route path="employee/edit/:id" element={<EmployeeSave />} />
            <Route path="inventoryaudit/:id" element={<InventoryAudit />} />
            <Route path="/ecommerce/bannerList/add" element={<BannerManagement />} />
            <Route path="ecommerce/bannerList/edit/:id" element={<BannerManagement />} />

            {/*REPORT*/}
            <Route path="report/example" element={<ReportExamplePage />} />
            <Route path="reportDetail" element={<ReportDetailpage />} />
            <Route path="report/annual-sales" element={<AnnualSales />} />
            <Route path="report/daily-cash-summary" element={<DailyCashSummaryPage />} />
            <Route path="report/product-sales" element={<ProductSales />} />
            <Route path="report/sales-summary" element={<SalesSummary />} />
            <Route path="report/tax-summary" element={<TaxSummary />} />
            <Route path="report/warehouse-transfer" element={<WarehouseTransfer />} />
            <Route path="report/transaction-details" element={<TransactionDetails />} />
            <Route path="report/budtender-average-sales" element={<BudtenderAvgSales />} />
            <Route path="report/inventory-level" element={<InventoryLevel />} />
            <Route path="report/shift-day" element={<ShiftByDay />} />
            <Route path="report/shift-employee" element={<ShiftByEmployee />} />
            <Route path="report/monthly-sales" element={<MonthlyProductSales />} />
            <Route path="report/employee-hours" element={<EmployeeTotalHours />} />
            <Route path="report/timesheet" element={<EmployeeTimesheet />} />
            <Route path="report/inventorySnapShot" element={<InventorySnapShot />} />
            <Route path="report/MonthlyInventory" element={<MonthlyInventory />} />
            <Route path="report/transaction-summary" element={<TransactionSummary />} />
            <Route path="report/sales-by-type" element={<SalesByType />} />
            <Route path="report/destroyed-product" element={<DestroyedProduct />} />
            <Route path="report/profit-report" element={<ProfitReport />} />
            <Route path="report/revenue-report" element={<RevenueReport />} />
            <Route path="report/customer-sales" element={<CustomerSales />} />
            <Route path="report/members-demographics" element={<MembersDemographics />} />
            <Route path="report/product-ranking" element={<ProductRankingReport />} />
            <Route path="report/restockbycaps" element={<RestockbyCaps />} />
            <Route path="report/discrepancy-report" element={<DiscrepancyReport />} />
            <Route path="report/manual-inventory-change" element={<ManualInventoryChange />} />
            <Route path="report/endofday" element={<EndOfDayReport />} />
            <Route path="report/reorder-report" element={<ReOrderReport />} />
            <Route path="report/credit-payments" element={<CreditPayments />} />
            <Route path="report/gift-card-balance" element={<GiftCardBalance />} />
            <Route path="report/category-sales" element={<CategorySales />} />
            <Route path="report/purchaseorder-report" element={<PurchaseOrderReport />} />
            <Route path="report/purchase-order-receiver" element={<PurchaseOrderReceiver />} />
            <Route path="report/sigma-report" element={<GeneralReport />} />
            <Route path="report/hourly-sales" element={<HourlySales />} />
            <Route path="report/discount-report" element={<DiscountReport />} />
            <Route path="report/daily-sales-report" element={<DailySalesReport />} />
            <Route path="report/monthly-sales-report" element={<MonthlySalesReport />} />
            <Route path="report/yearly-sales-report" element={<YearlySalesReport />} />
            <Route path="report/sell-through-report" element={<SellThroughReport />} />
            <Route path="report/daily-profit-report" element={<DailyProfitReport />} />
            <Route path="report/monthly-profit-report" element={<MonthlyProfitReport />} />
            <Route path="report/yearly-profit-report" element={<YearlyProfitReport />} />
            <Route path="report/gmroi-report" element={<GMROIReport />} />
            <Route path="report/shopping-trend" element={<ShoppingTrend />} />
            <Route path="report/aggregate-sales" element={<AggregateSales />} />
            <Route path="report/aggregate-inventory" element={<InventoryBranches />} />
            <Route path="report/budget-planner" element={<BudgetPlanner />} />
            <Route path="report/aggregate-branches" element={<AggregateBranches />} />
            <Route path="report/combined-sales" element={<CombinedSales />} />
            <Route path="report/aggregate-inventoryLevel" element={<AggregateInventoryLevel />} />
            <Route path="report/brand-sales" element={<BrandReport />} />
            <Route path="report/onlineinstore-sales" element={<OnlineInstore />} />
            <Route path="report/orderlist-sales" element={<OrderList />} />
            <Route path="report/inventoryage" element={<InventoryAge />} />
            <Route path="report/category-product" element={<CategoryProduct />} />
            <Route path="report/ircc" element={<IRCC />} />
            <Route path="report/hourly-sales-date-range" element={<HourlySalesDateRange />} />
            <Route path="report/hourly-sales-averaged" element={<HourlySalesSecondary />} />
            <Route path="report/product-price-change-report" element={<ProductPriceChangeReport />} />
            <Route path="report/delivery-report" element={<DeliveryReport />} />
            <Route path="report/gift-card-history" element={<GiftCardReport />} />
            <Route path="report/inventory-movement" element={<InventoryMovement />} />
            <Route path="report/inventory-log" element={<InventoryLogReport />} />
            <Route path="report/sales-summary-details" element={<SalesSummaryWithDetails />} />
            <Route path="report/aggregate-branch-sales-inventory" element={<AggregateBranchSalesInventory />} />
            <Route path="report/audit-report" element={<AuditReport />} />
            <Route path="report/uncounted-report" element={<UncountedReport />} />
            <Route path="report/management-reports" element={<HightideReports />} />
            <Route path="report/fiskaly-cash-point-closing-report" element={<FiskalyCashPointClosingReport/>}/>

            {/*ORDER*/}
            <Route path="admin/orders/open" element={<OpenOrderList />} />
            <Route path="admin/orders/detail/:id" element={<OrderDetailPage />} />

            {/*SUPPORT*/}
            <Route path="support-document" element={<SupportDocumentPage />} />

            {/*ADMIN*/}
            <Route path="admin/shift/add" element={<ShiftAddPage />} />
            <Route path="admin/shift/edit/:id/:date/:status" element={<ShiftEditPage />} />
            <Route path="admin/orders/detail" element={<OrderDetailPage />} />

            {/* WEB ADMIN */}
            <Route path="admin/menu/add" element={<WebAddMenuPage />} />
            <Route path="admin/coupon" element={<CouponPage />} />
            <Route path="admin/coupon/add" element={<CouponPage />} />
            <Route path="admin/coupon/edit" element={<EditCouponPage />} />
            <Route path="admin/general" element={<GeneralInfoPage />} />
            <Route path="admin/writing/faq" element={<FaqContentPage />} />
            <Route path="admin/writing/about" element={<AboutContentPage />} />
            <Route path="admin/writing/how-to" element={<HowtoContentPage />} />
            <Route path="admin/writing/legal" element={<LegalContentPage />} />
            <Route path="admin/writing/how-to/edit" element={<HowtoSave />} />

            {/*GIFT CARDS */}
            <Route path="admin/giftcard" element={<GiftCardPage />} />

            {/* PRICING */}
            <Route path="manage/pricing/mixandmatch" element={<MixAndMatchListPage />} />
            <Route path="manage/pricing/mixandmatch/add" element={<MixAndMatchSavePage />} />
            <Route path="manage/pricing/mixandmatch/edit/:id" element={<MixAndMatchSavePage />} />

            {/* TESTING - LOCK SCREEN */}
            <Route path="lock" element={<LockScreen />} />
            {/*Ecommerce */}

            <Route path="lock" element={<PinPadPassword />} />

            {/* GOVERNMENT - COMPLIANCE REPORT */}
            <Route path="/compliances" element={<ComplianceReport />} />
        </Route>
    ),
    {
        basename: folderName && window.location.pathname.startsWith(`/${folderName}`) ? `/${folderName}` : '/'
    }
);


class RoutesComponent extends Component {

    render() {

        return (
            <Provider store={this.props.store}>
                <RouterProvider router={router} />

            </Provider>
        )
    }
}


function mapStateToProps(state) {
    return {
    };
}

export default connect(mapStateToProps)(RoutesComponent);
